/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import "./views/components/FontAwesomeIcon";
import loadable from "@loadable/component";
import { useState, useEffect, Suspense } from "react";
import { requestForToken, onMessageListener } from "./helpers/firebase";
import { toastSuccess } from "./service/toast";
import { BrowserRouter as AppRouter, Switch, Route } from "react-router-dom";
import LayoutWrapper from "@layouts/components/layout-wrapper";
import { useRouterTransition } from "@hooks/useRouterTransition";
import { useLayout } from "@hooks/useLayout";
import { Routes } from "./router/routes/index";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Spinner from "./@core/components/spinner/Fallback-spinner";
import { isUserOnline } from "./service/user";
const BlankLayout = loadable(() => import("@layouts/BlankLayout"));
const HorizontalLayout = loadable(() =>
  import("@src/layouts/HorizontalLayout")
);
const VerticalLayout = loadable(() => import("@src/layouts/VerticalLayout"));
const Login = loadable(() => import("./views/Login"));

const App = (props) => {
  const [layout, setLayout] = useLayout();
  const [transition, setTransition] = useRouterTransition();
  const Layouts = { BlankLayout, VerticalLayout, HorizontalLayout };
  const Wizard = loadable(() => import("./views/Wizard"));
  const DefaultLayout =
    layout === "horizontal" ? "HorizontalLayout" : "VerticalLayout";
  requestForToken();

  const notify = (title, body ) => toastSuccess(<ToastDisplay title={title} body={body} />);

  function ToastDisplay({title, body}) {
    return (
      <>
        <h4>{title}</h4>
        <p>{body}</p>
      </>
    );
  }

  useEffect(() => {
    isUserOnline(true);
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      isUserOnline(false);
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleBeforeUnload);
    };
  }, []);

  onMessageListener()
    .then((payload) => {
      if (payload?.notification?.title) {
        notify(payload?.notification?.title, payload?.notification?.body);
      }
    })
    .catch((err) => {});

  const LayoutRoutesAndPaths = (layout) => {
    const LayoutRoutes = [];
    const LayoutPaths = [];
    if (Routes) {
      Routes.filter((route) => {
        if (
          route.layout === layout ||
          (route.layout === undefined && DefaultLayout === layout)
        ) {
          if (route.meta.authRoute) {
            LayoutRoutes.push(route);
            LayoutPaths.push(route.path);
          }
        }
      });
    }
    return { LayoutRoutes, LayoutPaths };
  };

  const privateRoutes = () => {
    return Object.keys(Layouts).map((layout, index) => {
      const LayoutTag = Layouts[layout];
      const { LayoutPaths } = LayoutRoutesAndPaths(layout);
      const routerProps = {};
      return (
        <Switch path={LayoutPaths} key={index}>
          <LayoutTag
            key={index}
            routerProps={routerProps}
            layout={layout}
            setLayout={setLayout}
            transition={transition}
            setTransition={setTransition}
            currentActiveItem={null}
          >
            <LayoutWrapper
              layout={DefaultLayout}
              transition={transition}
              setTransition={setTransition}
            >
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/"
                component={loadable(() => import("./views/Home"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/home"
                component={loadable(() => import("./views/Home"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/todos"
                component={loadable(() => import("./views/Todo"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/todos/:filter"
                component={loadable(() => import("./views/Todo"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/todos/tag/:tag"
                component={loadable(() => import("./views/Todo"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/tickets"
                component={loadable(() => import("./views/Tickets"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/leads"
                component={loadable(() => import("./views/Leads"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/chats"
                component={loadable(() => import("./views/Chat"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
                path="/setting"
                component={loadable(() => import("./views/Setting"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/bots"
                component={loadable(() => import("./views/Bot"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/bot/:id/questions"
                component={loadable(() => import("./views/BotQuestions"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/bot/:id/question/create"
                component={loadable(() => import("./views/BotQuestionCreate"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/bot/:id/question/:question/edit"
                component={loadable(() => import("./views/BotQuestionUpdate"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/bot/question/trainings"
                component={loadable(() =>
                  import("./views/BotQuestionTrainings")
                )}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/users"
                component={loadable(() => import("./views/User"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/user/admins"
                component={loadable(() =>
                  import("./views/components/Users/Admins")
                )}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/integrations/website"
                component={loadable(() =>
                  import("./views/components/BotComp/Deploy")
                )}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/integrations/slack"
                component={loadable(() =>
                  import("./views/components/BotComp/slack/index")
                )}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/integrations/hubspot"
                component={loadable(() =>
                  import("./views/components/BotComp/hubspot/index")
                )}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/meetings"
                component={loadable(() => import("./views/Meeting"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/questions"
                component={loadable(() => import("./views/Questions"))}
              />
              <PrivateRoute
                exact
                roles={["SUPER_ADMIN"]}
                path="/code"
                component={loadable(() => import("./views/Code"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/reporting"
                component={loadable(() => import("./views/Reporting"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/blogs"
                component={loadable(() => import("./views/Blog"))}
              />
              <PrivateRoute
                exact
                roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN"]}
                path="/channels"
                component={loadable(() => import("./views/Channels"))}
              />
            </LayoutWrapper>
          </LayoutTag>
        </Switch>
      );
    });
  };

  return (
    <AppRouter basename={process.env.REACT_APP_BASENAME}>
      <Suspense fallback={null}>
        <Switch>
          <PublicRoute
            exact
            path="/not-authorized"
            component={loadable(() => import("./views/NotAuthorized"))}
          />
          <PublicRoute
            exact
            path="/error"
            component={loadable(() => import("./views/Error"))}
          />
          {/* <PublicRoute
            exact
            path="/redemption-code"
            component={loadable(() => import("./views/CodeSignup"))}
          /> */}
          <PublicRoute
            exact
            path="/signup/"
            component={loadable(() => import("./views/SignUp"))}
          />
          <PublicRoute
            exact
            path="/forget-password/"
            component={loadable(() => import("./views/ForgetPassword"))}
          />
          <PublicRoute
            exact
            path="/reset-password/:resetToken"
            component={loadable(() => import("./views/PasswordResetForm"))}
          />
          <PublicRoute
            exact
            path="/verification/:token"
            component={loadable(() => import("./views/Verification"))}
          />
           <PublicRoute
            exact
            path="/resend-verification"
            component={loadable(() => import("./views/ResendVerification"))}
          />
          <PublicRoute
            exact
            path="/send-forget-email"
            component={loadable(() =>
              import("./views/components/forget-password-stuff/SendEmail")
            )}
          />
          <PublicRoute
            exact
            path="/reset-password-success"
            component={loadable(() =>
              import("./views/components/forget-password-stuff/PasswordReset")
            )}
          />
          <PublicRoute
            exact
            path="/"
            component={() => {
              return (
                <Suspense fallback={<Spinner />}>
                  <Login />
                </Suspense>
              );
            }}
          />
          <Route
            exact
            path="/wizard"
            render={() => {
              return (
                <Layouts.BlankLayout>
                  <Wizard />
                </Layouts.BlankLayout>
              );
            }}
          />
          <Route
            exact
            path="/verify-code"
            component={loadable(() => import("./views/VerifyEmailOtp"))}
          />
          <Route
            exact
            path="/verify-2fa"
            component={loadable(() => import("./views/VerifyOtp"))}
          />
          <PrivateRoute
            exact
            roles={["ADMIN", "SUPER_ADMIN", "SUB_ADMIN", "AGENT"]}
            path="/welcome"
            component={loadable(() => import("./views/Welcome"))}
          />
          {privateRoutes()}
        </Switch>
      </Suspense>
    </AppRouter>
  );
};

export default App;
